import { getAxiosHeaders } from '@api/config/axios';
import StandardButton from '@components/ui/buttons/standard-button';
import { Box, Container, Grid, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';

export default function DevEvalLink() {
  function generateUniquePhoneNumber(): string {
    // Get current timestamp in milliseconds
    const timestamp = Date.now(); // same as new Date().getTime()

    // Take the last 10 digits to make it a phone-number-like string
    const phoneNumber = '9' + timestamp.toString().slice(-9);

    return phoneNumber;
  }
  const phno = generateUniquePhoneNumber();
  const [additionalData, setAdditionalData] = useState(
    JSON.stringify(
      {
        agentId: 'agentId',
        studentId: phno,
        formId: '68cd5d27d4c8fa05cbf9c2e7',
        candidate: {
          mobile: '+91-' + phno,
          email: 'email@host.com'
        },
        evalInfo: [
          {
            evaluationProvider: 'tec',
            evaluationServiceType: 'evaluation'
          }
        ]
      },
      null,
      2
    )
  );
  const [resultUrl, setResultUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const parseAdditional = () => {
    try {
      const parsed = JSON.parse(additionalData || '{}');
      return parsed;
    } catch {
      return {};
    }
  };

  const handleTrigger = async () => {
    setIsLoading(true);
    setResultUrl('');
    try {
      const payload: any = {
        ...parseAdditional()
      };
      const res = await axios.post(
        'https://api.trential.dev/web-wallet/api/1.0/profile/candidate',
        payload,
        getAxiosHeaders({ 'x-api-key': import.meta.env.VITE_EVAL_LINK_X_API_KEY })
      );
      const apiUrl: string | undefined = res?.data?.data?.url;
      if (apiUrl) {
        try {
          const u = new URL(apiUrl);
          const finalUrl = `${window.location.origin}${u.pathname}${u.search}${u.hash}`;
          setResultUrl(finalUrl);
        } catch {
          setResultUrl(apiUrl.replace('https://wallet.trential.dev', window.location.origin));
        }
      }
    } catch {
      // noop
    } finally {
      setIsLoading(false);
    }
  };

  if (import.meta.env.VITE_ENV !== 'development') {
    return null;
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Generate Evaluation Link (Dev)
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="additional JSON (merged into body)"
            fullWidth
            multiline
            minRows={6}
            value={additionalData}
            onChange={(e) => setAdditionalData(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Phone number generated uniquely upon every refresh with 0.0000000001% collision
            probability
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <StandardButton fullWidth disabled={isLoading} onClick={handleTrigger}>
            {isLoading ? 'Generating…' : 'Generate Link'}
          </StandardButton>
        </Grid>
        {resultUrl && (
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Result:
              </Typography>
              <a
                href={resultUrl}
                target="_self"
                rel="noreferrer"
                style={{ wordBreak: 'break-word', fontSize: '2rem' }}>
                {resultUrl}
              </a>
            </Box>
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
